<script setup>
import SearchItem from "./treeViewSearchItem.vue";

const { items, messageSuggest, displayTag } = defineProps({
  items: Array | [],
  messageSuggest: String | "",
  displayTag: Boolean | true,
});
</script>

<template>
  <div style="display: contents">
    <p v-if="messageSuggest" class="suggest-message">
      {{ messageSuggest }}
    </p>
    <SearchItem
      v-for="item in items"
      :key="item.hash"
      :item="item"
      :parent-list="item.parentList"
      :display-tag="displayTag"
    />
  </div>
</template>

<style scoped lang="scss">
.suggest-message {
  color: var(--com-text--primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 125% */
  padding: 0.25rem 1rem;
  margin: 0;
  width: 100%;
}
</style>
